import React from 'react';
import cn from 'class-names';

import HorizontalScrollWithArrows from '@uikit/old/HorizontalScrollWithArrows/HorizontalScrollWithArrows';
import CreateItemComponent from '@uikit/old/Folders/_components/CreateItemComponent';

import './SectionSelect.scss';

type Props = {
  options: { key: any; title: React.ReactNode }[];
  getSelectedOption?: (option: { key: any; title: React.ReactNode }) => boolean;
  selectedOption?: any;
  entityName?: string;
  onChange: (value: any) => void;
  handleCreate?: (value: string) => void;
  Renderer?: ({
    onClick,
    isActive,
    item,
    onRemoveClick,
    onRenameClick,
  }: {
    onClick: () => void;
    item: { key: any; title: React.ReactNode };
    isActive: boolean;
    onRenameClick: (id: number, title: string) => Promise<void>;
    onRemoveClick: (id: number) => Promise<void>;
    testId?: string;
  }) => JSX.Element;
  classNames?: {
    container?: string;
  };
  onRenameClick?: (id: number, title: string) => Promise<void>;
  onRemoveClick?: (id: number) => Promise<void>;
  /** Hook base for the Renderer items and the create button (`${testId}-create`); nothing without it. */
  testId?: string;
};

function SectionSelect({
  options,
  selectedOption,
  getSelectedOption,
  onChange,
  handleCreate,
  entityName,
  classNames,
  Renderer,
  onRenameClick = (id: number, title: string) => Promise.resolve(),
  onRemoveClick = (id: number) => Promise.resolve(),
  testId,
}: Props): JSX.Element {
  return (
    <div
      className={cn('section-select', { [classNames?.container]: !!classNames?.container })}
      data-testid={testId}
    >
      <HorizontalScrollWithArrows className="section-select__container">
        {options.map((item) =>
          Renderer ? (
            <Renderer
              key={item.key}
              onClick={() => onChange(item.key)}
              item={item}
              isActive={getSelectedOption ? getSelectedOption(item) : selectedOption === item.key}
              onRemoveClick={onRemoveClick}
              onRenameClick={onRenameClick}
              testId={testId}
            />
          ) : (
            <div
              key={item.key}
              onClick={() => onChange(item.key)}
              className={cn('section-select__item', {
                'section-select__item--active': getSelectedOption
                  ? getSelectedOption(item)
                  : selectedOption === item.key,
              })}
            >
              {item.title}
            </div>
          )
        )}

        {handleCreate && (
          <CreateItemComponent
            entityName={entityName}
            onCreate={handleCreate}
            testId={testId ? `${testId}-create` : undefined}
          />
        )}
      </HorizontalScrollWithArrows>
    </div>
  );
}

export default SectionSelect;
